export default __webpack_public_path__ + "static/media/defient_image0-mobile.png.webp";